import { com } from '@eidu/form'
import { useState } from 'react'
import createSemanticLink from './api/analytics/createSemanticLink'
import { useSnackBar } from '../components/feedback/SnackBarProvider'
import SemanticLink = com.eidu.sharedlib.entity.analytics.SemanticLink
import SemanticLinkKey = com.eidu.sharedlib.entity.analytics.SemanticLinkKey
import EntityPath = com.eidu.sharedlib.entity.path.EntityPath
import semanticLinkIdFromString = com.eidu.sharedlib.entity.analytics.semanticLinkIdFromString

const useCreateSemanticLink = (onSuccess: () => void) => {
  const [isSaving, setIsSaving] = useState(false)
  const { showSnackBar } = useSnackBar()

  const save = async (key: SemanticLinkKey, path: EntityPath) => {
    setIsSaving(true)
    try {
      const newId = semanticLinkIdFromString(crypto.randomUUID())
      const newSemanticLink = new SemanticLink(newId, key, path)
      await createSemanticLink({ semanticLink: newSemanticLink })
      showSnackBar('Successfully created semantic link', 'success')
      onSuccess()
    } catch (error) {
      showSnackBar(`Error creating semantic link: ${error instanceof Error ? error.message : String(error)}`, 'error')
    } finally {
      setIsSaving(false)
    }
  }

  return { save, isSaving }
}

export default useCreateSemanticLink
